import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';
import { format } from 'date-fns-tz';
import { subDays } from 'date-fns';

export default Factory.extend({
  name() {
    return faker.person.firstName();
  },

  email() {
    return faker.internet.email();
  },

  department() {
    return faker.commerce.department();
  },

  afterCreate(employee, server) {
    // if caller passes in an explicit `null`, then don't create associated objects
    // if they don't pass in anything at all, then we create defaults
    if (employee.assignedDesks === undefined) {
      employee.assignedDesks = [server.create('graphql/desk', { assignedEmployee: employee })];
    }
    if (employee.assignments === undefined) {
      employee.assignments = [server.create('graphql/assignment', { employee })];
    }
    if (employee.attendancePerformance === undefined) {
      const ninetyDaysAgo = subDays(new Date(), 90);
      employee.attendancePerformance = server.create('graphql/attendance-performance', {
        onsiteMission: server.create('graphql/onsite-mission', {
          department: 'Engineering',
          created: format(ninetyDaysAgo, 'yyyyMMdd'),
          mission: 3,
          period: 'WEEK',
        }),
        insights: server.create('graphql/employee-attendance-insight', {
          meetsAttendancePolicy: true,
        }),
        averageWeeklyAttendance: 3.8,
      });
    }
  },
});
